module.exports = __webpack_public_path__ + "static/media/apple-homepod.19155984.png";